<p i18n>Please select a currency to edit.</p>
